export const apiConfigs = {
    baseURL : "https://havasazankh.ir/v1/",
};
